<template>
  <section class="faq py-6 bg-light">
    <div class="container">
      <div class="text-center mb-5">
        <span class="badge bg-primary-subtle text-primary mb-3">FAQ</span>
        <h2 class="display-5 fw-bold mb-3">Domande Frequenti</h2>
        <p class="lead text-muted">Tutto quello che devi sapere sul nostro software</p>
      </div>

      <div class="row justify-content-center">
        <div class="col-lg-10">
          <!-- Tabs per categorie -->
          <ul class="nav nav-pills mb-4 justify-content-center" id="faqTabs" role="tablist">
            <li class="nav-item" role="presentation">
              <button class="nav-link active" data-bs-toggle="pill" data-bs-target="#generale">
                Generale
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" data-bs-toggle="pill" data-bs-target="#auto">
                Gestione Auto
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" data-bs-toggle="pill" data-bs-target="#immobili">
                Gestione Immobili
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" data-bs-toggle="pill" data-bs-target="#funzionalita">
                Funzionalità
              </button>
            </li>
          </ul>

          <!-- Contenuto FAQ -->
          <div class="tab-content" id="faqContent">
            <!-- Generale -->
            <div class="tab-pane fade show active" id="generale">
              <div class="accordion" id="accordionGenerale">
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#generale1">
                      Cos'è ImmobilAutoManager?
                    </button>
                  </h2>
                  <div id="generale1" class="accordion-collapse collapse show" data-bs-parent="#accordionGenerale">
                    <div class="accordion-body">
                      ImmobilAutoManager è una piattaforma software completa che integra la gestione di concessionarie auto e agenzie immobiliari in un unico sistema. È progettato specificamente per operatori del Friuli Venezia Giulia che gestiscono sia un parco auto che un portfolio immobiliare.
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#generale2">
                      Come posso iniziare a utilizzare il software?
                    </button>
                  </h2>
                  <div id="generale2" class="accordion-collapse collapse" data-bs-parent="#accordionGenerale">
                    <div class="accordion-body">
                      Puoi richiedere una demo personalizzata attraverso il nostro form di contatto. Un nostro esperto ti guiderà attraverso tutte le funzionalità e ti aiuterà a configurare il sistema secondo le tue esigenze specifiche.
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#generale3">
                      È necessaria una formazione specifica per utilizzare il software?
                    </button>
                  </h2>
                  <div id="generale3" class="accordion-collapse collapse" data-bs-parent="#accordionGenerale">
                    <div class="accordion-body">
                      Offriamo un programma di formazione completo che include:
                      <ul>
                        <li>Training iniziale per tutto il personale</li>
                        <li>Documentazione dettagliata e guide utente</li>
                        <li>Supporto tecnico dedicato</li>
                        <li>Aggiornamenti periodici sulle nuove funzionalità</li>
                        <li>Sessioni di formazione avanzata su richiesta</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#generale4">
                      Il software è accessibile da dispositivi mobili?
                    </button>
                  </h2>
                  <div id="generale4" class="accordion-collapse collapse" data-bs-parent="#accordionGenerale">
                    <div class="accordion-body">
                      Sì, il software è completamente responsive e accessibile da qualsiasi dispositivo. Offriamo:
                      <ul>
                        <li>Interfaccia ottimizzata per smartphone e tablet</li>
                        <li>Accesso sicuro da qualsiasi browser</li>
                        <li>App mobile dedicata per funzioni chiave</li>
                        <li>Sincronizzazione in tempo reale tra dispositivi</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#generale5">
                      Quali sono i requisiti tecnici per utilizzare il software?
                    </button>
                  </h2>
                  <div id="generale5" class="accordion-collapse collapse" data-bs-parent="#accordionGenerale">
                    <div class="accordion-body">
                      I requisiti sono minimi:
                      <ul>
                        <li>Connessione internet stabile</li>
                        <li>Browser web aggiornato (Chrome, Firefox, Safari, Edge)</li>
                        <li>Dispositivo con risoluzione minima 1024x768</li>
                        <li>Sistema operativo Windows, Mac o Linux</li>
                        <li>2GB di RAM o superiore</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#generale6">
                      Come funziona il backup dei dati?
                    </button>
                  </h2>
                  <div id="generale6" class="accordion-collapse collapse" data-bs-parent="#accordionGenerale">
                    <div class="accordion-body">
                      Il sistema di backup è completamente automatizzato:
                      <ul>
                        <li>Backup incrementali ogni ora</li>
                        <li>Backup completi giornalieri</li>
                        <li>Conservazione dei backup per 30 giorni</li>
                        <li>Possibilità di backup manuali on-demand</li>
                        <li>Ripristino dati rapido in caso di necessità</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Gestione Auto -->
            <div class="tab-pane fade" id="auto">
              <div class="accordion" id="accordionAuto">
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#auto1">
                      Come gestisce il software il parco auto?
                    </button>
                  </h2>
                  <div id="auto1" class="accordion-collapse collapse show" data-bs-parent="#accordionAuto">
                    <div class="accordion-body">
                      Il software gestisce l'intero ciclo di vita dei veicoli, inclusi:
                      <ul>
                        <li>Schede tecniche dettagliate per ogni veicolo</li>
                        <li>Gestione documenti e scadenze (bollo, assicurazione, revisioni)</li>
                        <li>Tracking delle manutenzioni e interventi officina</li>
                        <li>Gestione vendite e contratti</li>
                        <li>Monitoraggio costi e ricavi per veicolo</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#auto2">
                      Come funziona la gestione dell'officina?
                    </button>
                  </h2>
                  <div id="auto2" class="accordion-collapse collapse" data-bs-parent="#accordionAuto">
                    <div class="accordion-body">
                      Il modulo officina include:
                      <ul>
                        <li>Pianificazione interventi e calendario appuntamenti</li>
                        <li>Gestione magazzino ricambi con scorte minime</li>
                        <li>Schede lavoro digitali</li>
                        <li>Preventivi e fatturazione automatica</li>
                        <li>Storico interventi per veicolo</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#auto3">
                      Come gestisce le pratiche amministrative dei veicoli?
                    </button>
                  </h2>
                  <div id="auto3" class="accordion-collapse collapse" data-bs-parent="#accordionAuto">
                    <div class="accordion-body">
                      Il software include un modulo completo per la gestione amministrativa:
                      <ul>
                        <li>Gestione completa del PRA e pratiche auto</li>
                        <li>Scadenziario automatico per bolli e assicurazioni</li>
                        <li>Gestione delle immatricolazioni e dei passaggi di proprietà</li>
                        <li>Archivio digitale di tutti i documenti</li>
                        <li>Integrazione con i principali sistemi assicurativi</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#auto4">
                      Come funziona la gestione delle prenotazioni test drive?
                    </button>
                  </h2>
                  <div id="auto4" class="accordion-collapse collapse" data-bs-parent="#accordionAuto">
                    <div class="accordion-body">
                      Il modulo test drive include:
                      <ul>
                        <li>Calendario prenotazioni online</li>
                        <li>Gestione disponibilità veicoli</li>
                        <li>Notifiche automatiche ai clienti</li>
                        <li>Raccolta feedback post test drive</li>
                        <li>Statistiche sulle conversioni</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#auto5">
                      Come gestisce il modulo di valutazione dell'usato?
                    </button>
                  </h2>
                  <div id="auto5" class="accordion-collapse collapse" data-bs-parent="#accordionAuto">
                    <div class="accordion-body">
                      Il sistema include strumenti avanzati per la valutazione:
                      <ul>
                        <li>Database valori di mercato aggiornato</li>
                        <li>Calcolo automatico del valore basato su parametri specifici</li>
                        <li>Storico manutenzioni e interventi</li>
                        <li>Comparazione con veicoli simili</li>
                        <li>Generazione report di valutazione PDF</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Gestione Immobili -->
            <div class="tab-pane fade" id="immobili">
              <div class="accordion" id="accordionImmobili">
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#immobili1">
                      Quali funzionalità offre per la gestione immobiliare?
                    </button>
                  </h2>
                  <div id="immobili1" class="accordion-collapse collapse show" data-bs-parent="#accordionImmobili">
                    <div class="accordion-body">
                      Il modulo immobiliare include:
                      <ul>
                        <li>Gestione completa del portfolio immobiliare</li>
                        <li>Schede dettagliate con planimetrie e documentazione</li>
                        <li>Gestione affitti e vendite</li>
                        <li>Matching automatico tra domanda e offerta</li>
                        <li>Gestione certificazioni e scadenze</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#immobili2">
                      Come gestisce i contratti di affitto?
                    </button>
                  </h2>
                  <div id="immobili2" class="accordion-collapse collapse" data-bs-parent="#accordionImmobili">
                    <div class="accordion-body">
                      La gestione degli affitti include:
                      <ul>
                        <li>Template contrattuali personalizzabili</li>
                        <li>Gestione pagamenti e scadenze</li>
                        <li>Rendicontazione automatica</li>
                        <li>Notifiche per scadenze e rinnovi</li>
                        <li>Archivio digitale documenti</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#immobili3">
                      Come gestisce gli annunci immobiliari?
                    </button>
                  </h2>
                  <div id="immobili3" class="accordion-collapse collapse" data-bs-parent="#accordionImmobili">
                    <div class="accordion-body">
                      Il sistema offre una gestione completa degli annunci:
                      <ul>
                        <li>Pubblicazione automatica su portali immobiliari</li>
                        <li>Gestione foto e virtual tour</li>
                        <li>SEO ottimizzato per ogni annuncio</li>
                        <li>Tracking delle visualizzazioni e contatti</li>
                        <li>Sistema di matching automatico con richieste clienti</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#immobili4">
                      Come funziona la gestione delle visite agli immobili?
                    </button>
                  </h2>
                  <div id="immobili4" class="accordion-collapse collapse" data-bs-parent="#accordionImmobili">
                    <div class="accordion-body">
                      Il sistema offre una gestione completa:
                      <ul>
                        <li>Calendario visite integrato</li>
                        <li>Gestione disponibilità agenti</li>
                        <li>Notifiche automatiche via email/SMS</li>
                        <li>Raccolta feedback post visita</li>
                        <li>Tracking delle conversioni</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#immobili5">
                      Come gestisce i contratti e la documentazione immobiliare?
                    </button>
                  </h2>
                  <div id="immobili5" class="accordion-collapse collapse" data-bs-parent="#accordionImmobili">
                    <div class="accordion-body">
                      Il modulo contratti include:
                      <ul>
                        <li>Template personalizzabili per ogni tipo di contratto</li>
                        <li>Generazione automatica documenti</li>
                        <li>Firma digitale integrata</li>
                        <li>Archivio digitale documenti</li>
                        <li>Gestione scadenze e rinnovi</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Funzionalità -->
            <div class="tab-pane fade" id="funzionalita">
              <div class="accordion" id="accordionFunzionalita">
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#funz1">
                      Quali report e statistiche fornisce il software?
                    </button>
                  </h2>
                  <div id="funz1" class="accordion-collapse collapse show" data-bs-parent="#accordionFunzionalita">
                    <div class="accordion-body">
                      Il sistema fornisce:
                      <ul>
                        <li>Dashboard personalizzabili per ogni settore</li>
                        <li>Statistiche vendite e affitti in tempo reale</li>
                        <li>Report finanziari dettagliati</li>
                        <li>Analisi performance per settore</li>
                        <li>Previsioni e trend di mercato</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#funz2">
                      Come gestisce la fatturazione elettronica?
                    </button>
                  </h2>
                  <div id="funz2" class="accordion-collapse collapse" data-bs-parent="#accordionFunzionalita">
                    <div class="accordion-body">
                      Il software include:
                      <ul>
                        <li>Generazione automatica fatture elettroniche</li>
                        <li>Integrazione con il Sistema di Interscambio (SDI)</li>
                        <li>Gestione fatture attive e passive</li>
                        <li>Archivio digitale conforme alla normativa</li>
                        <li>Report IVA e contabili</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#funz3">
                      Come gestisce la privacy e la sicurezza dei dati?
                    </button>
                  </h2>
                  <div id="funz3" class="accordion-collapse collapse" data-bs-parent="#accordionFunzionalita">
                    <div class="accordion-body">
                      Il software implementa rigorose misure di sicurezza:
                      <ul>
                        <li>Conformità completa al GDPR</li>
                        <li>Crittografia end-to-end dei dati sensibili</li>
                        <li>Backup automatici giornalieri</li>
                        <li>Sistema di permessi multilivello</li>
                        <li>Log dettagliati di tutte le operazioni</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#funz4">
                      Quali integrazioni offre il software?
                    </button>
                  </h2>
                  <div id="funz4" class="accordion-collapse collapse" data-bs-parent="#accordionFunzionalita">
                    <div class="accordion-body">
                      Il sistema si integra con numerosi servizi:
                      <ul>
                        <li>Principali software di contabilità</li>
                        <li>Portali immobiliari e automotive</li>
                        <li>Sistemi di pagamento online</li>
                        <li>CRM e strumenti di marketing</li>
                        <li>API personalizzabili per integrazioni specifiche</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#funz5">
                      Come funziona il sistema di reportistica?
                    </button>
                  </h2>
                  <div id="funz5" class="accordion-collapse collapse" data-bs-parent="#accordionFunzionalita">
                    <div class="accordion-body">
                      Il modulo di reporting offre:
                      <ul>
                        <li>Dashboard personalizzabili</li>
                        <li>Report predefiniti per ogni area</li>
                        <li>Generazione report personalizzati</li>
                        <li>Export in vari formati (PDF, Excel, CSV)</li>
                        <li>Grafici e statistiche interattive</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#funz6">
                      Come funziona la gestione degli utenti e dei permessi?
                    </button>
                  </h2>
                  <div id="funz6" class="accordion-collapse collapse" data-bs-parent="#accordionFunzionalita">
                    <div class="accordion-body">
                      Il sistema offre un controllo completo:
                      <ul>
                        <li>Ruoli utente personalizzabili</li>
                        <li>Permessi granulari per ogni funzione</li>
                        <li>Log delle attività utente</li>
                        <li>Autenticazione a due fattori</li>
                        <li>Gestione team e filiali</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FAQ',
  data() {
    return {
      searchQuery: ''
    }
  },
  methods: {
    filterQuestions(query) {
      this.searchQuery = query.toLowerCase()

      // Seleziona tutti gli elementi accordion-item
      const items = document.querySelectorAll('.accordion-item')

      items.forEach(item => {
        const question = item.querySelector('.accordion-button').textContent.toLowerCase()
        const answer = item.querySelector('.accordion-body').textContent.toLowerCase()

        if (query === '' || question.includes(query) || answer.includes(query)) {
          item.style.display = ''
        } else {
          item.style.display = 'none'
        }
      })
    }
  }
}
</script>

<style scoped>
.badge {
  background: #8ecae6 !important;
  color: #023047 !important;
}

.nav-pills .nav-link {
  color: #023047 !important;
}

.nav-pills .nav-link.active {
  background: #219ebc !important;
}

.nav-pills .nav-link:hover {
  color: #219ebc !important;
}

.accordion-item {
  margin-bottom: 1rem;
  border-radius: 0.5rem;
  overflow: hidden;
}

.accordion-button:not(.collapsed) {
  background: #8ecae6 !important;
  color: #023047 !important;
}

.accordion-button:focus {
  border-color: #219ebc !important;
  box-shadow: 0 0 0 0.25rem rgba(33, 158, 188, 0.1);
}
</style>
